import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import * as APIModels from "../../../../models";

export type CaseSelectModalProps = {
    show: boolean;
    cases: APIModels.CourtCase[];
    onSelect: (selectedCase: APIModels.CourtCase) => void;
    onClose: () => void;
};

export default function CaseSelectModal({
    show,
    cases,
    onSelect,
    onClose,
}: CaseSelectModalProps) {
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Select Case
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {cases.map((v) => (
                    <div className="row m-2">
                        <div className="col-sm-4">{v.ucn}</div>
                        <div className="col-sm-4">{v.caseNumber}</div>
                        <div className="col-sm-4">{v.caseTitle}</div>
                        <div className="col-sm-2">
                            <Button onClick={() => onSelect(v)}>Select</Button>
                        </div>
                    </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
